import AppConfig from "~/config";
import { serializeLookupParameters } from "@/helpers/utils";

export default {

  computed: {
    remoteLookupApiKey() { return this.$store.getters.apiKey; },
    remoteLookupUrl() {
      const path = "app/lookup/"
      return `${AppConfig.api.baseUrl}${path}`
    }
  },
  

  methods: {
    remoteLookup(lookupType, params) {
      params["appVersion"] = AppConfig.runtime.version
      return fetch(this.remoteLookupUrl + lookupType + '?' + serializeLookupParameters(params), {
        method: 'GET',
        mode: 'cors',
        cache: 'no-cache',
        headers: {
          'Accept': 'application/json',
          'Authorization': this.remoteLookupApiKey,
          'Content-Type': 'application/json',
        },
        referrerPolicy: 'no-referrer'
      })
          .then(response => {

            if ([200, 201, 202].includes(response.status)) {
              return response.json()
            } else {
              throw(response)
            }
          })
          .catch(error => {
            if (error.message) {
              this.$store.dispatch('newAlert', { type: 'error', message: error.message})
            }
            throw(error)
          });

    },
    remotePost(lookupType, params) {
      params["appVersion"] = AppConfig.runtime.version
      return fetch(this.remoteLookupUrl + lookupType, {
        method: 'POST',
        mode: 'cors',
        cache: 'no-cache',
        headers: {
          'Accept': 'application/json',
          'Authorization': this.remoteLookupApiKey,
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(params),
        referrerPolicy: 'no-referrer'
      })
          .then(response => {

            if ([200, 201, 202].includes(response.status)) {
              return response.json()
            } else {
              throw(response)
            }
          })
          .catch(error => {
            if (error.message) {
              this.$store.dispatch('newAlert', { type: 'error', message: error.message})
            }
            throw(error)
          });

    }
  },

}
